/*eslint-disable*/
import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import CustomNoRowsOverlay from "./customNoRowsOverlay";
import { LicenseManager } from 'ag-grid-enterprise';
import TitleBar from "../titleBar/title_bar";
import { Button, Header, Icon, Input, Loader } from "semantic-ui-react";
import { Link } from "react-router-dom";
import ImportFile from "../modalComponent/importFile";
import CustomLoadingCellRenderer from "./agGridLoader";

LicenseManager.setLicenseKey('Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545');


class AgGridTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: AllModules,
            defaultColDef: {
                // editable: true,
                sortable: true,
                flex: 1,
                minWidth: 150,
                filter: true,
                resizable: true,
                enableValue: true,
                enableRowGroup: true,
                enablePivot: true,

            },
            openBox: false,
            openBranchBox : false,
            openBox : false,
            openVehicleBox : false,
            cacheBlockSize: 100,
            maxBlocksInCache: 10,
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel",
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel",
                    },
                ],
                defaultToolPanel: "",
            },
            isLoading: true,
            rowItems : [],
            rowData: [],
            searchValue: "",
            frameworkComponents: {
                customLoadingCellRenderer: CustomLoadingCellRenderer,
                approveRenderer: props.approveButton,
                actionRenderer: props.actionButton,
                customNoRowsOverlay: CustomNoRowsOverlay,
                ...props.extraComponents
            },
            loadingCellRenderer: 'customLoadingCellRenderer',
            loadingCellRendererParams: { loadingMessage: 'One moment please...' },
            noRowsOverlayComponent: "customNoRowsOverlay",
            noRowsOverlayComponentParams: {
                noRowsMessageFunc: function () {
                    return "No Record(s) Found";
                },
            },
        };
    }
    handleChange = (e) => {
        this.setState({ searchValue: e.target.value });
    };
    getParams() {
        return {
            columnGroups: true,
            fileName: this.props.titleBarTitle,
        };
    }
    onBtnExportDataAsExcel = () => {
        var params = this.getParams();
        this.gridApi.exportDataAsExcel(params);
    };
    importDataGrid = () => {
        // console.log("import the data grid");
    };
    filterChanged = (e) => {
        if (this.gridApi.getDisplayedRowCount() === 0) {
            this.gridApi.showNoRowsOverlay();
        } else {
            this.gridApi.hideOverlay();
        }
    };
    onGridReady = (prams) => {
        this.gridApi = prams.api;
        this.gridColumnApi = prams.columnApi;
        this.setState({
            isLoading: this.props.isLoading,
        });
        this.gridColumnApi.autoSizeAllColumns('', false);
    };

    sizeToFit = (prams) => {
        this.gridApi = prams.api;
        this.gridApi.sizeColumnsToFit();
      };

    exportDataGrid = (data) => {
        if (data) {
            let keys = []
            this.props.columnDefs.forEach(element => {
                element.field != "edit" && keys.push(element.headerName)
            });
            // console.log(keys)
            let param = {
                fileName: this.props.titleBarTitle,
            };
            this.gridApi.exportDataAsExcel(param);
        }
    };

    autoSizeAll = (skipHeader) => {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    };

    render() {

        return (
            <>
                {this.props.mode === 'create' ? '' : <TitleBar title={this.props.titleBarTitle}  hiddenNew={this.props.hiddenNew} LinkName={this.props.linkToNew}>
                    <Input size="mini" hidden={this.props.searchbar} iconPosition="left" icon={{ name: 'search', circular: true }} onChange={this.handleChange} className="mr-1 searchInput" placeholder="Search..." />
                    <Button className="w3-text-white" as={Link} to='#' hidden={this.props.hiddenOEBtn} size="mini" type="button" primary>Run Engine</Button>
                    <Button onClick={this.handleImport} hidden={this.props.importhidden} size="mini" basic color="facebook" icon><i className="icon"><img alt="import" src="assets/svg/import.svg" /></i> Import</Button>
                    <Button size="mini" type="button" hidden={this.props.exporthidden} basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/export.svg" /></i> Export</Button>
                    <ImportFile openBox={this.state.openBox} updated={this.props.updated} handleClose={this.handleClose} />
                    {this.props.moreTitleComponents}
                </TitleBar>}
                <div style={{ width: '100%', height: '100%' }}>
                    <div className="example-wrapper">
                        <div
                            id="myGrid"
                            style={{
                                height: '100%',
                                width: '100%',
                            }}
                            className="ag-theme-material"
                        >

                            {this.props.serverData && this.props.serverData.length > 0? <AgGridReact
                                domLayout="autoHeight"
                                modules={this.state.modules}
                                sideBar={this.state.sideBar}
                                rowGroupPanelShow={"always"}
                                quickFilterText={this.state.searchValue}
                                suppressAutoSize={true}
                                columnDefs={this.props.columnDefs}
                                defaultColDef={this.state.defaultColDef}
                                frameworkComponents={this.state.frameworkComponents}
                                loadingCellRenderer={this.state.loadingCellRenderer}
                                loadingCellRendererParams={this.state.loadingCellRendererParams}
                                rowSelection="multiple"
                                noRowsOverlayComponent={this.state.noRowsOverlayComponent}
                                noRowsOverlayComponentParams={this.state.noRowsOverlayComponentParams}
                                rowData={this.props.rowData}
                                pagination={this.props.pagination}
                                baseURL={this.props.baseURL}
                                paginationPageSize={10}
                                onGridReady={this.onGridReady}
                                exportBtn={this.exportDataGrid}
                                cacheBlockSize={this.state.cacheBlockSize}
                                maxBlocksInCache={this.state.maxBlocksInCache}
                                animateRows={true}
                                debug={true}
                                onFilterChanged={this.filterChanged}
                                onRowSelected={this.props.rowSelected}
                                {...this.props}
                            /> : this.props.serverData && this.props.loading === true ?
                                    <div className="m-5 p-5">
                                        <Loader active inline='centered'>Loading...</Loader>
                                    </div> :  null
                                    
                            }

                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default AgGridTable;